import React, { Component } from 'react';

class Loading extends Component {

  render() {
    return (
      <div className="loading">
        Loading
      </div>
    );
  }

}

export default Loading;
